import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { LookupService } from "../../../../shared/services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { NewRequestService } from "../../../../shared/models/request/new-request/new-request-service";
import { CategoryServicesService } from "../../../../shared/services/category-services.service";
import { ServiceItem } from "../../../../shared/models/services/service-item";
import { CellClickEvent, GridComponent, SaveEvent } from "@progress/kendo-angular-grid";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { NewRequestDevice } from "../../../../shared/models/request/new-request/new-request-device";
import { HierarchyLookupModel } from "../../../../shared/models/core/HierarchyLookupModel";
import { DeviceModelsService } from "../../../../shared/services/device-models.service";
import { DeviceModelDto } from "../../../../shared/models/device/device-model-dto";
import { RequestType } from "../../../../shared/enums";
import { CustomerObjectDeviceDto } from "../../../../shared/models/customerObject/customer-object-device";
import { DialogService } from "@progress/kendo-angular-dialog";
import { ServicesHierarchicalSelectorComponent } from "../../../../shared/components/services-hierarchical-selector/services-hierarchical-selector.component";
import { DevicesHierarchicalSelectorComponent } from "../../../../shared/components/devices-hierarchical-selector/devices-hierarchical-selector.component";
import { RequestTypeService } from "../../../../shared/services/request-type.service";
import { ReclamationDevicesService } from "../../../../shared/services/reclamation-devices.service";
import { ReclamationDeviceDto } from "../../../../shared/models/reclamation/reclamation-device.dto";
import { RequestReclamationDeviceDto } from "../../../../shared/models/reclamation/request-reclamation-device.dto";
import { ReclamationDeviceDeviceModelDto } from "../../../../shared/models/reclamation/reclamation-device-device-model.dto";
import { NotificationService } from "../../../../core/services/notification.service";
import { SecurityService } from "../../../../core/services/security.service";
import { DeviceTypesService } from "../../../../shared/services/device-types.service";
import { DeviceTypeDto } from "../../../../shared/models/device/device-type.dto";
import { NotificationType } from "../../../../core/services/notification-type";
import { CostCentersService } from "../../../../shared/services/cost-centers.service";
import { CostCenterWithAppointment } from "../../../../shared/models/cost-center/cost-center-with-appointment";

@Component({
	selector: 'new-request-services-and-devices',
	templateUrl: './new-request-services-and-devices.component.html',
	styleUrls: ['./new-request-services-and-devices.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class NewRequestServicesAndDevicesComponent implements OnInit {

    @ViewChild("servicesGrid") servicesGrid: GridComponent;
    @ViewChild("requestDevicesGrid") requestDevicesGrid: GridComponent;
    @ViewChild("reclamationDevicesGrid") reclamationDevicesGrid: GridComponent;

    @Input() disabled: boolean;
    @Input() requestTypeId: number;
    @Input() requestCategoryId: number;
    @Input() serviceCenterId: number;
    serviceCentersLookup: KeyValueObject[] = [];
    
    @Output() saveRequestServices: EventEmitter<NewRequestService[]> = new EventEmitter();
    @Output() saveRequestDevices: EventEmitter<NewRequestDevice[]> = new EventEmitter();
    @Output() saveRequestReclamationDeviceId: EventEmitter<number> = new EventEmitter();

    private defaultServiceTypeId = 2;
    private defailtServiceCategoryId = 4;
	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    requestReclamationDevices: RequestReclamationDeviceDto[] = [];

    roleForceDiscount: boolean;
    roleDiscountLimit: number;
    maxDiscountLimit: number;
    defaultCostCenterId: number;
    requireCostCenterManually: boolean;

    fullServices: ServiceItem[] = [];
    services: KeyValueObject[] = [];
    installTypes: KeyValueObject[] = [];
    marketPlaces: KeyValueObject[] = [];
    warrantyRequestTypes: number[] = [];
    fullCostCenters: CostCenterWithAppointment[] = [];
    costCenters: KeyValueObject[] = [];
    reclamationProductGroups: KeyValueObject[] = [];
    reclamationDevices: ReclamationDeviceDto[] = [];
    reclamationDevicesDropdownData: KeyValueObject[] = [];
    reclamationDeviceModels: ReclamationDeviceDeviceModelDto[] = [];

    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    deviceTypeFullItems: DeviceTypeDto[] = [];

    requestServices: NewRequestService[] = [];
    requestDevices: NewRequestDevice[] = [];
    customerObjectDevices: CustomerObjectDeviceDto[] = [];

    constructor(
        public categoryServicesService: CategoryServicesService,
        public deviceModelsService: DeviceModelsService,
        public lookupService: LookupService,
        public dialogService: DialogService,
        public requestTypesService: RequestTypeService,
        public reclamationDevicesService: ReclamationDevicesService,
        public notificationService: NotificationService,
        public deviceTypesService: DeviceTypesService,
        public securityService: SecurityService,
        public costCentersService: CostCentersService
    ) { }

    ngOnInit(): void {
        this.roleForceDiscount = this.securityService.currentUser.forceDiscount;
        this.roleDiscountLimit = this.securityService.currentUser.discountLimit;

        let fullServices$ = this.categoryServicesService.list();
        let deviceTypes$ = this.lookupService.getData('device-types', null);
		let deviceModels$ = this.deviceModelsService.getAll();
        let installTypes$ = this.lookupService.getData('device-install-types', null);
        let marketPlaces$ = this.lookupService.getData('device-market-places', null);
        let warrantyRequestTypes$ = this.requestTypesService.getWarrantyRequestTypes();
        let reclamationProductGroups$ = this.lookupService.getData('reclamation-product-groups', null);
        let reclamationDevices$ = this.reclamationDevicesService.getAll();
        let reclamationDeviceModels$ = this.reclamationDevicesService.getAllReclamationDeviceModels();
        let allDeviceTypes$ = this.deviceTypesService.getAllDeviceTypesNoCategory();
        let fullCostCenters$ = this.costCentersService.getAllWithAppointments();
        let serviceCenters$ = this.lookupService.getData('service-centers', null);

        forkJoin(
            fullServices$, 
            deviceTypes$,  
            deviceModels$, 
            installTypes$, 
            marketPlaces$, 
            warrantyRequestTypes$,
            reclamationProductGroups$,
            reclamationDevices$,
            reclamationDeviceModels$,
            allDeviceTypes$,
            fullCostCenters$,
            serviceCenters$)
            .subscribe(([
                fullServices, 
                deviceTypes, 
                deviceModels, 
                installTypes, 
                marketPlaces, 
                warrantyRequestTypes,
                reclamationProductGroups,
                reclamationDevices,
                reclamationDeviceModels,
                allDeviceTypes,
                fullCostCenters,
                serviceCenters
            ]) => {
                this.services = fullServices.data.map(x => new KeyValueObject(x.id, x.name));
                this.fullServices = fullServices.data;
                this.installTypes = installTypes;
                this.marketPlaces = marketPlaces;
                this.warrantyRequestTypes = warrantyRequestTypes;
                this.reclamationProductGroups = reclamationProductGroups;
                this.reclamationDevices = reclamationDevices;
                this.reclamationDeviceModels = reclamationDeviceModels;
                this.reclamationDevicesDropdownData = this.reclamationDevices.map(x => new KeyValueObject(x.reclamationDeviceId, x.name));

                this.deviceTypes = deviceTypes;
                this.deviceModels = deviceModels;
                this.dropDownDeviceModels = this.deviceModels;
                this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
                this.dropDownDeviceSuppliers = this.deviceSuppliers;
                this.deviceTypeFullItems = allDeviceTypes;
                this.fullCostCenters = fullCostCenters;
                this.costCenters = fullCostCenters.map(x => new KeyValueObject(x.costCenterId, `${x.code} ${x.name}`));
                this.serviceCentersLookup = serviceCenters || [];
            });
    }

    setCustomerObjectDevices(customerObjectDevices: CustomerObjectDeviceDto[] = []): void {
        if (this.isReclamation) {
            this.customerObjectDevices = [];
            this.requestDevices = customerObjectDevices.map(x => {
                let requestDevice = new NewRequestDevice;
                requestDevice.serialNumber = x.serialNumber;
                requestDevice.deviceModelId = x.deviceModelId;
                requestDevice.deviceTypeId = x.deviceTypeId;
                requestDevice.marketPlaceId = x.marketPlaceId;
                requestDevice.installTypeId = x.installTypeId;
                requestDevice.deviceSupplierId = x.deviceSupplierId;
                requestDevice.deviceId = x.deviceId;
                requestDevice.inReclamation = false;
                return requestDevice;
            });
            this.refreshRequestDevices();
            return;
        }

        if (this.isService) {
            this.customerObjectDevices = (customerObjectDevices || []).map(x => ({
                ...x,
                existInRequestDevices: false
            }));
            // При возврате с Рекламации в requestDevices оставалось всё оборудование объекта
            this.requestDevices = [];
            this.refreshRequestDevices();
            return;
        }

        this.customerObjectDevices = [];
        this.requestDevices = [];
        this.refreshRequestDevices();
    }

    onChangeCustomerObjectDeviceForService(event: any, dataItem: CustomerObjectDeviceDto) {
        dataItem.existInRequestDevices = event.target.checked;
        this.refreshRequestDevices();
    }

    private mapCustomerObjectDeviceToRequestDevice(device: CustomerObjectDeviceDto): NewRequestDevice {
        return {
            deviceId: device.deviceId,
            deviceModelId: device.deviceModelId,
            deviceTypeId: device.deviceTypeId,
            deviceSupplierId: device.deviceSupplierId,
            serialNumber: device.serialNumber,
            quantity: 1,
            inClaim: true,
            customerDevice: true,
            cost: 0,
            fullCost: 0,
            discount: 0
        } as NewRequestDevice;
    }

    changeRequestTypeAndCategory(requestTypeId: number, requestCategoryId: number) {
        if (requestTypeId == null || requestTypeId == 0 || 
            requestCategoryId == null || requestCategoryId == 0) {
            this.requestServices = [];
            return;
        }

        this.services = this.fullServices
            /*.filter(x => x.serviceRequestTypes.some(srt => 
                srt.requestTypeId == requestTypeId && 
                srt.requestCategoryId == requestCategoryId)) */
            .map(srt => new KeyValueObject(srt.id, srt.name));

        if (requestTypeId && requestCategoryId && requestTypeId != 0 && requestCategoryId != 0) {
            let costCenter = this.fullCostCenters.find(x => 
                x.appointments.some(a => a.requestTypeId == requestTypeId && a.requestCategoryId == requestCategoryId));
            
            if (costCenter == null) {
                this.requireCostCenterManually = true;
                this.defaultCostCenterId = null;
            }
            else {
                this.defaultCostCenterId = costCenter.costCenterId;
            }
        }

        this.requestServices = this.fullServices
            .filter(x => x.serviceRequestTypes.some(srt => 
                srt.requestTypeId == requestTypeId && 
                srt.requestCategoryId == requestCategoryId && 
                srt.isDefault == true))
            .map(x => {
                let cost = this.fullServices.find(s => s.id == x.id).cost;

                return {
                    serviceId: x.id,
                    serviceName: x.name,
                    serviceTypeId: this.defaultServiceTypeId,
                    serviceCategoryId: this.defailtServiceCategoryId,
                    isDefault: true,
                    count: 1,
                    fullCost: cost,
                    cost: cost,
                    costCenterId: this.defaultCostCenterId
                } as NewRequestService;
            });

        this.requestDevices.filter(x => !x.customerDevice).forEach(x => x.costCenterId = this.defaultCostCenterId);

        this.saveRequestServices.emit(this.requestServices);
        this.refreshRequestDevices();
    }

    setCostCenter(costCenterId: number) {
        this.defaultCostCenterId = costCenterId;

        this.requestDevices.filter(x => !x.customerDevice).forEach(x => x.costCenterId = this.defaultCostCenterId);
        this.requestServices.forEach(x => x.costCenterId = this.defaultCostCenterId);
    }

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    getDeviceModelName(deviceModelId: number): string {
        return this.deviceModels.some(x => x.id == deviceModelId)
            ? this.deviceModels.find(x => x.id == deviceModelId).name
            : '';
    }

    refreshRequestServices() {
        this.saveRequestServices.emit(this.requestServices);
    }

    createNewService(): NewRequestService {
        let service = { 
            serviceTypeId: this.defaultServiceTypeId,
            serviceCategoryId: this.defailtServiceCategoryId,
            costCenterId: this.defaultCostCenterId
        } as NewRequestService;

        return service;
    }

    getServiceCostServWithDiscount(requestService: NewRequestService): number {
        if (requestService.fullCost && requestService.discount) {
            let cost = requestService.fullCost - (requestService.fullCost * requestService.discount / 100);
            return Number.isInteger(cost) ? cost : Math.floor(cost); //: parseFloat(cost.toFixed(2));
        }

        return requestService.fullCost;
    }

    getServiceSum(requestService: NewRequestService): number {
        return requestService.count * this.getServiceCostServWithDiscount(requestService);
    }

    serviceRequireCostCenter(requestService: NewRequestService) {
        return requestService.costCenterId == null;
    }

    getServiceCostCenterName(requestService: NewRequestService): string {
        if (this.serviceRequireCostCenter(requestService)) {
            return 'Укажите'
        }
        
        return this.getNameById(this.costCenters, requestService.costCenterId);
    }

    get totalServicePrice(): number {
        const priceServices = this.requestServices.some(x => x.isDone)
            ? this.requestServices.filter(x => x.isDone)
            : this.requestServices;

        const totalPrice = priceServices.reduce((sum, item) => sum + (this.getServiceCostServWithDiscount(item) * item.count), 0);

        return Math.floor(totalPrice);
    }

    get totalDevicePrice(): number {
       const totalPrice = this.requestDevices.reduce((sum, item) => sum + (this.getDeviceCostWithDiscount(item) * item.quantity), 0);

       return Math.floor(totalPrice);
    }

    get totalPrice(): number {
        return this.totalServicePrice + this.totalDevicePrice;
    }

    changeServiceDiscountLevel(rate: number) {
        if (rate != null) {
            this.requestServices.forEach(x => {
                let maxDiscount = this.calculateServiceMaxDiscountLimit(x, true);
                x.discount = maxDiscount * rate;
            });
        }
        else {
            this.requestServices.forEach(requestService => requestService.discount = requestService.discountPrimary);
        }
    }

    calculateServiceMaxDiscountLimit(requestService: NewRequestService, forDiscountLevel: boolean = false): number {
        if (this.roleForceDiscount) {
            if (forDiscountLevel) {
                this.maxDiscountLimit = this.fullServices.find(x => x.id == requestService.serviceId).discountLimit;
            }
            else {
                this.maxDiscountLimit = 100;
            }
        }
        else if (requestService.serviceId != null) {
            let serviceDiscountLimit = this.fullServices.find(x => x.id == requestService.serviceId).discountLimit;
            this.maxDiscountLimit = this.roleDiscountLimit > serviceDiscountLimit
                ? serviceDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.maxDiscountLimit = 0;
        }

        return this.maxDiscountLimit;
    }

    cellClickServiceHandler({ dataItem, sender, rowIndex, columnIndex }: any) {
        if (columnIndex < 8) {
            this.editServiceHandler({ dataItem, sender, rowIndex });
        }
    }
    
    editServiceHandler({ dataItem, sender, rowIndex }: any) {
        this.calculateServiceMaxDiscountLimit(dataItem);
        sender.editRow(rowIndex);
    }

    addNewService() {
        const dialogRef = this.dialogService.open({ 
            content: ServicesHierarchicalSelectorComponent, 
            title: 'Добавление услуг',
            width: '80%',
            height: '820px',
            minWidth: '800px'
        });
        const serviceSelector = <ServicesHierarchicalSelectorComponent>dialogRef.content.instance;

        serviceSelector.height = 460;
        serviceSelector.defaultRequestTypeId = this.requestTypeId;
        serviceSelector.defaultRequestCategoryId = this.requestCategoryId;
        serviceSelector.existingServices = this.requestServices;
        serviceSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        serviceSelector.onContinue.subscribe((services: NewRequestService[]) => {
            services.forEach(service => {
                let cost = this.fullServices.find(s => s.id == service.serviceId).cost;
                this.requestServices.push({
                    serviceTypeId: this.defaultServiceTypeId,
                    serviceCategoryId: this.defailtServiceCategoryId,
                    serviceId: service.serviceId,
                    count: service.count,
                    cost: cost,
                    fullCost: cost,
                    costCenterId: this.defaultCostCenterId
                } as NewRequestService)
            });
            this.refreshRequestServices();
            dialogRef.close();
        });

		//this.servicesGrid.addRow(this.createNewService());
	}

    getServiceArticleNumber(serviceId: number): string {
        let service = this.fullServices.find(x => x.id == serviceId);
        return service == null ? '' : service.articleNumber;
    }

    createNewReclamationDevice(): RequestReclamationDeviceDto {
        let device = new RequestReclamationDeviceDto();
        return device;
    }

    addNewReclamationDevice() {
        this.reclamationDevicesGrid.addRow(this.createNewReclamationDevice());
    }

    getReclamationDeviceName(reclamationDeviceId: number): string {
        return reclamationDeviceId ?
            this.reclamationDevices.find(x => x.reclamationDeviceId == reclamationDeviceId).name
            : '';
    }

    handleReclamationDevicesDropdownOpen(reclamationProductGroupId: number) {
        this.reclamationDevicesDropdownData = this.reclamationDevices
            .filter(x => x.reclamationProductGroupId == reclamationProductGroupId)
            .map(x => new KeyValueObject(x.reclamationDeviceId, x.name));
    }

    changeReclamationProductGroupd(groupId: number, dataItem: RequestReclamationDeviceDto) {
        dataItem.reclamationDeviceId = null;
    }

    refreshRequestReclamationDevice(event: SaveEvent) {
        let requestReclamationDevice = event == null || event.dataItem == null
            ? this.requestReclamationDevices[0]
            : event.dataItem;

        let reclamationDeviceId = requestReclamationDevice != null
            ? requestReclamationDevice.reclamationDeviceId
            : null;

        this.saveRequestReclamationDeviceId.emit(reclamationDeviceId);

        if (reclamationDeviceId != null && this.isReclamation) {
            let deviceModelIds = this.reclamationDeviceModels.filter(x =>
                x.reclamationDeviceId == reclamationDeviceId).map(x => x.deviceModelId);

            if (deviceModelIds.length > 0) {
                if (this.requestDevices.some(x => x.deviceModelId == deviceModelIds[0])) {
                    this.notificationService.confirmation({
                        title: 'Подтвердите добавление оборудования',
                        message: 'Оборудование такой модели уже есть на этом объекте обслуживания. Добавить еще?',
                        showCloseButton: false,
                        showConfirmButton: true,
                        showCancelButton: true,
                        cancelButtonText: 'Отменить',
                        confirmButtonText: 'Добавить'
                    }, 
                    () => { this.addRequestDeviceFromReclamation(deviceModelIds[0]) });
                }
                else {
                    this.addRequestDeviceFromReclamation(deviceModelIds[0]);
                }
            }
        }
    }

    addRequestDeviceFromReclamation(deviceModelId: number) {
        this.requestDevices.push({
            deviceModelId: deviceModelId,
            quantity: 1,
            inReclamation: true,
            inClaim: true,
            costCenterId: this.defaultCostCenterId 
        } as NewRequestDevice);
        this.refreshRequestDevices();
    }

    saveRequestDevice({ dataItem }) {
        this.refreshRequestDevices();
    }

    refreshRequestDevices() {
        if (this.isService) {
            const serviceObjectDevices = this.customerObjectDevices
                .filter(x => x.existInRequestDevices)
                .map(x => this.mapCustomerObjectDeviceToRequestDevice(x));

            this.saveRequestDevices.emit([...this.requestDevices, ...serviceObjectDevices]);
            return;
        }

        this.saveRequestDevices.emit(this.requestDevices);
    }

    getDeviceSum(requestDevice: NewRequestDevice): number {
        return requestDevice.quantity * this.getDeviceCostWithDiscount(requestDevice);
    }

    deviceDiscountChange(dataItem: NewRequestDevice) {
        if (this.deviceDiscountInvalid(dataItem) && dataItem.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.maxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }
    
    deviceDiscountInvalid(requestDevice: NewRequestDevice): boolean {
        return requestDevice.discount != null &&
            (requestDevice.discount < 0 ||
                requestDevice.discount > 100 ||
                requestDevice.discount > this.maxDiscountLimit);
    }

    changeDeviceDiscountLevel(rate: number) {
        if (rate != null) {
            this.requestDevices.map(x => {
                let maxDiscount = this.calculateDeviceMaxDiscountLimit(x, true);
                x.discount = maxDiscount * rate;
            });
        }
        else {
            this.requestDevices.forEach(x => x.discount = x.discountPrimary);
        }
    }

    calculateDeviceMaxDiscountLimit(requestDevice: NewRequestDevice | CustomerObjectDeviceDto, forDiscountLevel: boolean = false): number {
        if (this.roleForceDiscount) {
            if (forDiscountLevel) {
                this.maxDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            }
            else {
                this.maxDiscountLimit = 100;
            }
        }
        else if (requestDevice.deviceTypeId != null) {
            let deviceTypeDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            this.maxDiscountLimit = this.roleDiscountLimit > deviceTypeDiscountLimit
                ? deviceTypeDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.maxDiscountLimit = 0;
        }

        return this.maxDiscountLimit;
    }

    getDeviceCostWithDiscount(requestDevice: NewRequestDevice): number {
        if (requestDevice.fullCost && requestDevice.discount) {
            let cost = requestDevice.fullCost - (requestDevice.fullCost * requestDevice.discount / 100);
            return Number.isInteger(cost) ? cost : Math.floor(cost); // : parseFloat(cost.toFixed(2));
        }

        return requestDevice.fullCost;
    }

    cellClickDeviceHandler({ dataItem, sender, rowIndex, columnIndex }: any) {
        if (columnIndex < 9) {
            this.editDeviceHandler({ dataItem, sender, rowIndex });
        }
    }

    editDeviceHandler({ dataItem, sender, rowIndex }: any) {
        this.calculateDeviceMaxDiscountLimit(dataItem);
        sender.editRow(rowIndex);
    }

    createNewRequestDevice(): NewRequestDevice {
        let device = new NewRequestDevice();
        device.inReclamation = true;
        device.inClaim = this.isReclamation;
        device.quantity = 1;
        device.requestDeviceId = 0;
        if (this.skipInventory) {
            device.customerDevice = true;
            device.cost = 0;
        }
        return device;
    }

    addNewCustomerRequestDevice() {
        this.dropDownDeviceModels = this.deviceModels;
        this.requestDevicesGrid.addRow(this.createNewRequestDevice());
    }

    addNewRequestDevice() {
        if (this.isReclamation || this.skipInventory) {
            this.addNewCustomerRequestDevice();
            return;
        }

        const dialogRef = this.dialogService.open({ 
            content: DevicesHierarchicalSelectorComponent, 
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.defaultRequestCategoryId = this.requestCategoryId;
        devicesSelector.disableFreeItems = !this.isWarrantyRequest;
        devicesSelector.isReclamation = this.isReclamation;
        devicesSelector.serviceCenterId = this.serviceCenterId;

        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            requestDevices.forEach(requestDevice => {
                requestDevice.inReclamation = true;
                requestDevice.inClaim = true;
                requestDevice.requestDeviceId = 0;
                requestDevice.costCenterId = this.defaultCostCenterId;
                
                const existingDevice = this.requestDevices.find(x => x.deviceModelId === requestDevice.deviceModelId);
                if (existingDevice) {
                    existingDevice.quantity += requestDevice.quantity
                } else {
                    this.requestDevices.push(requestDevice);
                }
            });

            this.refreshRequestDevices();
            dialogRef.close();
        });

        //this.requestDevicesGrid.addRow(this.createNewRequestDevice())
    }

    onChangeDeviceReclamation(event: any, dataItem: NewRequestDevice) {
        dataItem.inReclamation = event.target.checked;
        dataItem.inClaim = event.target.checked;
        this.refreshRequestDevices();

        let lastReclamationDevices = dataItem.inReclamation
            ? dataItem
            : this.requestDevices.find(x => x.inReclamation);

        if (lastReclamationDevices != null) {
            let reclamationDeviceModel = this.reclamationDeviceModels.find(x => x.deviceModelId == lastReclamationDevices.deviceModelId);

            if (reclamationDeviceModel != null) {
                if (this.requestReclamationDevices.length == 0) {
                    this.requestReclamationDevices.push(new RequestReclamationDeviceDto());
                }

                let reclamationDevice = this.reclamationDevices.find(x => x.reclamationDeviceId == reclamationDeviceModel.reclamationDeviceId);
                this.requestReclamationDevices[0].reclamationProductGroupId = reclamationDevice.reclamationProductGroupId;
                this.requestReclamationDevices[0].reclamationDeviceId = reclamationDevice.reclamationDeviceId;

                this.reclamationDevicesDropdownData = this.reclamationDevices.map(x => new KeyValueObject(x.reclamationDeviceId, x.name));
                this.refreshRequestReclamationDevice(null);
            }
        }
        else {
            this.requestReclamationDevices = [];
            this.refreshRequestReclamationDevice(null);
        }
    }

    changeRequestDeviceCustomerDevice(event: any, requestDevice: NewRequestDevice) {
        requestDevice.costCenterId = event.target.checked
            ? null
            : this.defaultCostCenterId;
    }

    deviceRequireCostCenter(requestDevice: NewRequestDevice) {
        return requestDevice.costCenterId == null && !requestDevice.customerDevice;
    }

    getDeviceCostCenterName(requestDevice: NewRequestDevice): string {
        if (this.deviceRequireCostCenter(requestDevice)) {
            return 'Укажите'
        }

        return this.getNameById(this.costCenters, requestDevice.costCenterId);
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }
    }

    public deviceSupplierChange(supplierId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
        }
    }

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

    public get costCentersCompleted(): boolean {
        return this.requestDevices.every(x => !this.deviceRequireCostCenter(x)) &&
            this.requestServices.every(x => !this.serviceRequireCostCenter(x));
    }

    get hasDiscountRight(): boolean {
        return this.securityService.hasClaim('role-Discounting-right');
    }

    get isReclamation(): boolean {
        return this.requestTypeId == <number>RequestType.reclamation;
    }

    get isService(): boolean {
        return this.requestTypeId == <number>RequestType.service;
    }

    get isWarrantyRequest(): boolean {
        return this.warrantyRequestTypes.some(x => x == this.requestTypeId);
    }

    get canAddDevice(): boolean {
        return (this.serviceCenterId != null && this.serviceCenterId != 0) || this.isReclamation;
    }

    get skipInventory(): boolean {
        const selected = (this.serviceCentersLookup || []).find(x => x.id === this.serviceCenterId);
        return !!(selected && selected.skipInventory);
    }

    get canAddFromCatalog(): boolean {
        return this.canAddDevice && !this.skipInventory;
    }
}
